import { render, staticRenderFns } from "./newStory.vue?vue&type=template&id=2f72cb6d&scoped=true&"
import script from "./newStory.vue?vue&type=script&lang=js&"
export * from "./newStory.vue?vue&type=script&lang=js&"
import style0 from "./newStory.vue?vue&type=style&index=0&id=2f72cb6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f72cb6d",
  null
  
)

export default component.exports